export default __webpack_public_path__ + "static/media/logo-bioshop.23986bfc.png";